import { DateTime } from 'luxon';

import { TaskKeysFilterModel } from './TaskKeysFilterModel';

type FiltersModelDependencies = {
  getTimesheetData: () => any;
  getCurrentDate: () => DateTime;
  getView: () => string;
  setFilterData: (data: any) => void;
};

export class FiltersModel {
  readonly taskKeys: TaskKeysFilterModel;

  constructor(dependencies: FiltersModelDependencies) {
    this.taskKeys = new TaskKeysFilterModel(dependencies);
  }
}
